'use client';

import { CSSProperties } from 'react';
import {
	TOAST_BACKGROUND_CLASSNAME,
	TOAST_ROUNDED_CLASSNAME,
	TOAST_SHADOW_CLASSNAME,
	TOAST_TEST_ID,
	TOAST_WIDTH_CLASSNAME,
} from 'src/components/Toasts/consts';
import { cj } from 'src/utils/classNames';
import { WithChildren } from 'src/utils/UtilityTypes';

interface Props extends WithChildren {
	style?: CSSProperties;
}

export default function AlertToast({ children, style }: Props) {
	return (
		<div
			className={cj(
				'relative overflow-hidden border border-stroke-divider',
				'pointer-events-auto text-text-default',
				TOAST_BACKGROUND_CLASSNAME,
				TOAST_ROUNDED_CLASSNAME,
				TOAST_SHADOW_CLASSNAME,
				TOAST_WIDTH_CLASSNAME
			)}
			style={style}
			data-testid={TOAST_TEST_ID}
		>
			{children}
		</div>
	);
}
